import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader.jsx';
import Card from '../components/Card.jsx';

export default function NotFoundPage() {
  return (
    <>
      <PageHeader eyebrow="404" title="Page not found" subtitle="That address does not match any screen in this app." />
      <Card>
        <p className="muted" style={{ fontSize: 12.5, marginTop: 0 }}>
          Pick a module from the sidebar, or head back to the dashboard.
        </p>
        <div className="btn-row">
          <Link className="btn primary" to="/" style={{ textDecoration: 'none' }}>
            Go to dashboard
          </Link>
        </div>
      </Card>
    </>
  );
}
